import { Stack } from '@mui/material';
import { TextInput, required, useRecordContext } from 'react-admin';
import ImageEditorField from '@app/misc/ImageEditorField';
import { UrlInput } from '@app/misc/UrlInput';
import { FormationInput } from '@domain/formation';
import { useResource } from '@app/misc/useResource';
import { showModeReadOnlySx } from '@app/root/theme';

export const FormationInputs = ({
    readOnly = false,
}: {
    readOnly?: boolean;
}) => {
    const record = useRecordContext<FormationInput>();
    const { data: coverSrc } = useResource(record?.coverId);

    return (
        <Stack gap={1} p={1} sx={readOnly ? showModeReadOnlySx : undefined}>
            <TextInput
                source="name"
                helperText={false}
                validate={required()}
                readOnly={readOnly}
            />
            <ImageEditorField
                source="coverInput"
                height={200}
                emptyText={`${record?.id ?? ''}`}
                linkPosition="bottom"
                src={coverSrc ?? undefined}
                readOnly={readOnly}
            />
            <TextInput
                source="description"
                helperText={'Description of the formation'}
                multiline
                readOnly={readOnly}
            />
            <UrlInput
                source="url"
                helperText={'URL of the formation'}
                readOnly={readOnly}
            />
        </Stack>
    );
};
